var render = function render(){var _vm=this,_c=_vm._self._c;return _c('print-relatorio',{attrs:{"is-loading":_vm.isLoading}},[(!_vm.isLoading)?_c('div',{staticClass:"r-table print-view-folha-a4"},[(_vm.dados && _vm.dados.template)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.dados.template.template)}}):_c('div',{staticStyle:{"padding":"50px"}},[_vm._v(" "+_vm._s(_vm.dados)+" ")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }